import React, { useState, useEffect } from "react";

import "./ApiDetails.scss";

const url = "https://api.appmingleconsultants.com/apiDetails";

const ApiDetails = () => {
    const [api_secret, setSecretKey] = useState("");
    const [api_token, setApiKey] = useState("");
    const [originalSecretKey, setOriginalSecretKey] = useState("");
    const [originalApiKey, setOriginalApiKey] = useState("");
    const [isSaveEnabled, setIsSaveEnabled] = useState(false);

    // Fetch existing keys on component load
    useEffect(() => {
        const fetchKeys = async () => {
            try {
                const response = await fetch(url, {
                    method: "GET",
                });
                const data = await response.json();
                setSecretKey(data.api_secret || "");
                setApiKey(data.api_token || "");
                setOriginalSecretKey(data.api_secret || "");
                setOriginalApiKey(data.api_token || "");
            } catch (error) {
                console.error("Error fetching API details:", error);
            }
        };

        fetchKeys();
    }, []);

    // Enable Save button if there's a change
    useEffect(() => {
        setIsSaveEnabled(
            api_secret !== originalSecretKey || api_token !== originalApiKey
        );
    }, [api_secret, api_token, originalSecretKey, originalApiKey]);

    // Handle Save button click
    const handleSave = async () => {
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ api_secret, api_token }),
            });

            if (response.ok) {
                alert("API details saved successfully!");
                setOriginalSecretKey(api_secret);
                setOriginalApiKey(api_token);
                setIsSaveEnabled(false);
            } else {
                alert("Failed to save API details. Please try again.");
            }
        } catch (error) {
            console.error("Error saving API details:", error);
        }
    };

    return (
        <div className="api-details-container">
            <h1 className="title">Set API Details</h1>
            <div className="form-group">
                <label htmlFor="api_secret">Secret Key</label>
                <input
                    type="text"
                    id="api_secret"
                    value={api_secret}
                    onChange={(e) => setSecretKey(e.target.value)}
                    placeholder="Enter your secret key"
                />
            </div>
            <div className="form-group">
                <label htmlFor="api_token">API Key</label>
                <input
                    type="text"
                    id="api_token"
                    value={api_token}
                    onChange={(e) => setApiKey(e.target.value)}
                    placeholder="Enter your API key"
                />
            </div>
            <button
                className="save-button"
                onClick={handleSave}
                disabled={!isSaveEnabled}
            >
                Save
            </button>
        </div>
    );
};

export default ApiDetails;
